
import React from "react";

export default function AdminDashboard() {
    return (
        <div style={{ padding: "20px" }}>
            <h1>Панель администратора</h1>
            <p>Управление пользователями, профилями и организациями.</p>
        </div>
    );
}